
import Vue from 'vue'
import VueRouter from 'vue-router'

// 📦 懒加载方式引入页面组件（推荐）
const Home = () => import(/* webpackChunkName: "home" */ '@/views/Home')
const About = () => import(/* webpackChunkName: "about" */ '@/views/About')
const Download = () => import(/* webpackChunkName: "Download" */ '@/views/Download.vue')
const Technology = () => import(/* webpackChunkName: "Download" */ '@/views/Technology.vue')
const Case = () => import(/* webpackChunkName: "Download" */ '@/views/Case.vue')
const News = () => import(/* webpackChunkName: "Download" */ '@/views/News.vue')
const Product = () => import(/* webpackChunkName: "Download" */ '@/views/Product.vue')
const ProductContent = () => import(/* webpackChunkName: "Download" */ '@/components/ProductContent.vue')
const Hh = () => import(/* webpackChunkName: "Download" */ '@/views/Hh.vue')
const Qfj = () => import(/* webpackChunkName: "Download" */ '@/views/Qfj.vue')
const Mtyr = () => import(/* webpackChunkName: "Download" */ '@/views/Mtyr.vue')
const Mtyn = () => import(/* webpackChunkName: "Download" */ '@/views/Mtyn.vue')
const PostDetail = () => import(/* webpackChunkName: "Download" */ '@/views/PostDetail.vue')
const YanBuJi = () => import(/* webpackChunkName: "Download" */ '@/views/Ybj.vue')
const QT = () => import(/* webpackChunkName: "Download" */ '@/views/Qt.vue')

// 启用 VueRouter 插件
Vue.use(VueRouter)

// 定义所有页面的子路由（children），比如 home、about、Download...
const commonRoutes = [
    {path: 'home', component: Home},
    {path: 'about', component: About},
    {path: 'download', component: Download},
    {path: 'technology', component: Technology},
    {path: 'case', component: Case},
    {path: 'news', component: News},
    {
        path: 'product', component: Product,
        children: [
            {path: '', component: ProductContent},
            {path: 'ybj', component: YanBuJi},
            {path: 'qt', component: QT},
            {path: 'hh', component: Hh},
            {path: 'mtyr', component: Mtyr},
            {path: 'mtyn', component: Mtyn},
            {path: 'qfj', component: Qfj},
        ]
    },
    {path: 'postDetail/:id', component: PostDetail, props: true},


    // 新增页面，只在这里加一次 ✅
]

// 定义路由表
const routes = [
    {
        path: '/en',
        component: () => import('@/layouts/LangLayout.vue'), // 可选：语言布局组件
        children: commonRoutes,
    },
    {
        path: '/zh',
        component: () => import('@/layouts/LangLayout.vue'), // 可选：中文布局
        children: commonRoutes,
    },
]

// 创建路由实例
const router = new VueRouter({
    mode: 'history', // 可选：使用 history 模式（需服务器支持）
    base: process.env.BASE_URL,
    routes,
})

// ✅ 全局前置守卫：根据路由前缀自动设置语言
router.beforeEach((to, from, next) => {
    if (to.path.startsWith('/public/')) {
        next(); // 直接放行，不执行后续逻辑
        return;
    }

    // 路径以 /en/ 或 /zh/ 开头
    const langMatch = to.path.match(/^\/(en|zh)\//)

    if (langMatch) {
        const lang = langMatch[1] // 'en' 或 'zh'

        // 将当前语言设置到 i18n 实例中
        const i18n = router.app.$i18n  // ✅ 获取 i18n 实例

        if (i18n) {
            i18n.locale = lang  // 动态设置当前语言
        }
        // （可选）你也可以存到 localStorage，以便刷新后记住语言
        localStorage.setItem('locale', lang)
        next()
    } else {
        let locale = localStorage.getItem('locale') || 'zh' //默认值为zh
        if (to.path === '/') {
            next(`/${locale}/home`) //为/时直接跳到主页
        }

        else {
            next(`/${locale}${to.path}`)
        } //其他情况添加上对应的语言前缀
    }
})

export default router